<ng-container class="root" *transloco="let t; read: 'replacementCardRequest'">
    <div class="root">
        <ng-container *ngIf="(formSubmitSucceded$ | async) !== true else successMessage">
            <h1 class="root__heading">{{ t("heading") }}</h1>

            <div class="root__info">{{ t("information")}}</div>

            <div class="root__info" *ngIf="isCertificateExpiring$ | async">{{ t("expirationInformation")}}</div>

            <form [formGroup]="form" (ngSubmit)="onSubmit()" [ngxsFormDebounce]="0" ngxsForm="replacementCard.form">
                <h2 class="root__heading2">{{ t("invoiceAddressHeading") }}</h2>
                <address-form [form]="invoiceAddress" [countryCodes]="countryCodes$ | async" read="replacementCardRequest"></address-form>

                <ha-checkbox class="root__delivery-same-as-invoice" formControlName="deliverySameAsInvoice" [label]="t('deliverySameAsInvoice')"></ha-checkbox>
                <ng-container *ngIf="!deliverySameAsInvoice">
                    <h2 class="root__heading2">{{ t("deliveryAddressHeading") }}</h2>
                    <address-form [form]="deliveryAddress" [countryCodes]="countryCodes$ | async" read="replacementCardRequest"></address-form>
                </ng-container>

                <h2 class="root__heading2">{{ t("sendInvoiceAsEmail") }}</h2>
                <input-radio-group formControlName="sendInvoiceAsEmail" [list]="sendInvoiceAsEmailOptions"></input-radio-group>

                <ha-input *ngIf="sendInvoiceAsEmail" autocomplete="email" formControlName="emailForInvoice" [label]="t('emailForInvoice')">
                </ha-input>

                <hr class="root__divider">

                <ha-checkbox class="root__agreement" (click)="openAgreement($event)" formControlName="agreementAccepted" [label]="t('agreementAccepted')">
                </ha-checkbox>

                <validation-messages [read]="['replacementCardRequest', 'addressForm']" [form]="form" [validationResult]="validationResult$ | async">
                </validation-messages>

                <div class="root__buttons">
                    <a class="root__buttons__cancel-button" type="button" routerLink="..">{{ t("cancel") }}</a>
                    <button class="root__buttons__save-button" type="submit" [loading]="createAction">{{ t("submit") }}</button>
                </div>
            </form>
        </ng-container>

        <ng-template #successMessage>
            <h1 class="root__heading">{{ t("successHeading") }}</h1>
            <div class="root__success-message" [innerHTML]="t('successMessage')"></div>

            <div class="root__go-back" routerLink="/">{{ t("backToStart") }}</div>
        </ng-template>
    </div>

    <modal #agreementModal [closeLabel]="t('close')" width="wide" textSource="from-editor">
        <div *ngIf="agreementText$ | async as agreement" [innerHTML]="agreement"></div>
    </modal>
</ng-container>
